module.exports = __webpack_public_path__ + "static/excluding2-473445687d19cf79344f0ebe9092c073.png";